import formatNodes from '../helpers/formatNodes'
import { getAllNodes } from 'utils/queries'
import buildNodeHierarchy from 'utils/buildNodeHierarchy'

export default async ({ props, path, graphql }) => {
  const result = await graphql.query(getAllNodes())

  return path.loaded({
    nodes: formatNodes(buildNodeHierarchy(result.nodesFlatten))
  })
}



// WEBPACK FOOTER //
// ./src/modules/Node/actions/getAllNodes.js